module.exports = __webpack_public_path__ + "static/media/desktopIcon.717f0581.svg";